import { FormControl, FormLabel, FormErrorMessage } from '@chakra-ui/react';

import CustomIconButton from '../utils/CustomIconButton';
import Popover from '../utils/Popover';

import { ReactComponent as InfoIcon } from '../../icons/info.svg';

// This component will remain as the only FormField
// The other clone in utils folder will be deleted when the whole field refactor is completed

const FormField = ({ label, children, error, info, ...props }) => {
    return (
        <FormControl {...props}>
            {info && (
                <Popover
                    placement="top"
                    trigger={<CustomIconButton mt="0px !important" mr="5px !important" icon={<InfoIcon />} />}
                >
                    {info}
                </Popover>
            )}

            <FormLabel>{label}</FormLabel>

            {children}

            <FormErrorMessage>{error}</FormErrorMessage>
        </FormControl>
    );
};
export default FormField;
